import { render, staticRenderFns } from "./radioDoctor.vue?vue&type=template&id=6fd9f95a&scoped=true&"
import script from "./radioDoctor.vue?vue&type=script&lang=js&"
export * from "./radioDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9f95a",
  null
  
)

export default component.exports